module.exports = __webpack_public_path__ + "img/lazy.331a4346.gif";